import React, { useEffect, useRef, useState } from 'react';
import { useApi } from '../hooks/useApi';

// Tomorrow's BASE / Fixing I / Fixing II prices in the DB (/market-data-status),
// checked once per page load: the navigation bar stays mounted across tabs, so
// this runs again only on a browser refresh. Green = in the DB (Fixing: every
// quarter of the day), red = not yet, grey = still checking or the check failed.
const ITEMS = [
  { key: 'base', label: 'BASE' },
  { key: 'fixing_i', label: 'Fixing I', quarters: 'fixing_i_quarters' },
  { key: 'fixing_ii', label: 'Fixing II', quarters: 'fixing_ii_quarters' },
];

const MarketDataStatus = ({ darkMode = false }) => {
  const { fetchGet } = useApi();
  const [status, setStatus] = useState(null);
  const checked = useRef(false);

  useEffect(() => {
    if (checked.current) return;
    checked.current = true;
    fetchGet('/market-data-status')
      .then(response => response.json())
      .then(setStatus)
      .catch(err => setStatus({ status: 'error', message: err.message }));
  }, [fetchGet]);

  const ok = status?.status === 'success';
  return (
    <div className="flex items-center space-x-3 text-xs font-medium">
      {ITEMS.map(({ key, label, quarters }) => {
        const available = ok ? status[key] : null;
        // emerald/rose, not green/red: the dark theme's [class*='bg-green-50'] /
        // [class*='bg-red-50'] selectors in index.css also match bg-green-500 / bg-red-500.
        const dot = available == null
          ? (darkMode ? 'bg-slate-500' : 'bg-gray-300')
          : (available ? 'bg-emerald-500' : 'bg-rose-500');
        const title = !status
          ? `${label}: checking…`
          : !ok
            ? `${label}: check failed — ${status.message || 'unknown error'}`
            : `${label} ${status.date}: ${available ? 'in the DB' : 'not in the DB yet'}`
              + (quarters ? ` (${status[quarters]}/${status.expected_quarters} quarters)` : '');
        return (
          <span
            key={key}
            title={title}
            className={`inline-flex items-center gap-1.5 whitespace-nowrap ${darkMode ? 'text-slate-200' : 'text-gray-700'}`}
          >
            <span className={`h-2.5 w-2.5 rounded-full ${dot}`} />
            {label}
          </span>
        );
      })}
    </div>
  );
};

export default MarketDataStatus;
